export default "__VITE_ASSET__BTs6JC8l__"